const SET_USER = 'SET_USER';
const SET_USER_ROLES = 'SET_USER_ROLES';
const GET_ORGANIZATIONS = 'GET_ORGANIZATIONS';
const GET_CURRENT_USER = 'GET_CURRENT_USER';
const GET_USER_ROLES = 'GET_USER_ROLES';
const CLEAR = 'CLEAR';
const GET_USERS = 'GET_USERS';
const GET_USER = 'GET_USER';

export default {
	SET_USER,
	GET_ORGANIZATIONS,
	GET_CURRENT_USER,
	CLEAR,
	GET_USER_ROLES,
	SET_USER_ROLES,
	GET_USERS,
	GET_USER,
};
